import React, { useContext, useState } from 'react'
import styles from "./header.module.css";
import header_logo from "../../assets/header_logo.png";
import Modal from "../modal/index";
import Authentication from '../authentication';
import { AuthContext } from '../../contextAPI';
import logout_logo from "../../assets/logout.png"
import calendar_logo from "../../assets/calendar.png"
import SchedulePopUp from './schedulePopUp';


const Header = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);

  const User = useContext(AuthContext);

  const onLogoutHandler = () => {
    if(!User)return
    
    const element = document.getElementById('logout');
    
    element?.scrollIntoView({
      behavior: 'smooth'
    });

    return User.logout()
  }

  const showUserAppointments = () => {
    setShowScheduleModal(true)
  }

  return (
    <>
      <Modal
        show={showLoginModal}
        onClose={()=>{setShowLoginModal(false)}}
      >
        <Authentication onSubmit={()=>{setShowLoginModal(false)}} />
      </Modal>

      <Modal 
        show={showScheduleModal}
        onClose={()=>{setShowScheduleModal(false)}}
      >
        <SchedulePopUp onClose={()=>{setShowScheduleModal(false)}} />
      </Modal>

      <div className={styles.container} id='logout'>
        {
          User.isLoggedIn &&
          <>
            <div className={styles.controllers}>
              <img onClick={onLogoutHandler} src={logout_logo} alt=''/> 
              <img onClick={showUserAppointments} src={calendar_logo} alt=''/> 
            </div>
          </>
        }
        <img className={styles.header_img} onClick={()=>{setShowLoginModal(true)}} src={header_logo} alt='' />
        <div className={styles.header}>
          <h2>Massage Therapist 🥥</h2>  
        </div>
      </div>
    </>
  )
}

export default Header